import { Injectable } from '@angular/core';

import { Action, Actions, Selector, State, StateContext } from '@ngxs/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import {
  ReferralsPortalApplication,
  ReferralsPortalApplicationStatus,
} from '@recruitee/http/types';

import { HttpApiService } from '../../../core/http-api.service';
import {
  EntityState,
  EntityStateHelpers,
  EntityUpdateStrategy,
  IEntityState,
} from '../../../core/state';
import { LoadApplications, SubmitApplication } from './application.actions';

@State({
  name: 'application',
  defaults: EntityStateHelpers.createDefaultState(),
})
@Injectable()
export class ReferralsApplicationRepo extends EntityState<ReferralsPortalApplication>() {
  @Selector([ReferralsApplicationRepo.entities])
  public static successful(entities: ReferralsPortalApplication[]): ReferralsPortalApplication[] {
    return (entities || []).filter(
      entity => entity.status === ReferralsPortalApplicationStatus.Success,
    );
  }

  @Selector([ReferralsApplicationRepo.entities])
  public static notSuccessful(
    entities: ReferralsPortalApplication[],
  ): ReferralsPortalApplication[] {
    return (entities || []).filter(
      entity => entity.status !== ReferralsPortalApplicationStatus.Success,
    );
  }

  constructor(private httpApi: HttpApiService, private actions$: Actions) {
    super(actions$, EntityUpdateStrategy.update);
  }

  @Action(SubmitApplication)
  public sendApplication(ctx: StateContext<any>, action: SubmitApplication): Observable<any> {
    return this.httpApi.post('/applications', null, { application: action.payload });
  }

  @Action(LoadApplications)
  public loadApplications(
    ctx: StateContext<IEntityState<ReferralsPortalApplication>>,
    action: LoadApplications,
  ): Observable<any> {
    return this.httpApi
      .get('/applications')
      .pipe(
        tap((response: { applications: ReferralsPortalApplication[] }) =>
          this.saveMany(ctx, action, response.applications),
        ),
      );
  }
}
